import * as React from "react"

type Props = {
  name: string
  description?: string
}

const SubHeader: React.FC<Props> = ({ name, description }) => {
  return (
    <>
      <h2>{name}</h2>
      {description && <p>{description}</p>}
    </>
  )
}

export default SubHeader
